import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAdmin } from "@/admin/store";
import { IMG } from "@/veedu/data";
import { Field, inputCls } from "@/components/admin/ui";

const AdminLogin = () => {
  const { login, authed, loading } = useAdmin();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  if (loading) return <div className="flex h-screen items-center justify-center bg-ink text-cream">Loading...</div>;
  if (authed) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    const success = await login(username, password);
    if (success) {
      navigate("/admin", { replace: true });
    } else {
      setError("The credentials do not match our records or are invalid.");
    }
  };

  return (
    <div data-testid="admin-login" className="relative flex min-h-screen items-center justify-center bg-ink px-5">
      <img src={IMG.door} alt="" className="absolute inset-0 h-full w-full object-cover opacity-15" />
      <div className="absolute inset-0 bg-gradient-to-b from-ink/70 via-ink/80 to-ink" />
      <div className="relative z-10 w-full max-w-sm">
        <div className="text-center">
          <p className="font-mal text-lg text-brass/80">വീട്</p>
          <h1 className="mt-3 font-display text-3xl tracking-[0.15em] text-ivory">VEEDU ADMIN</h1>
          <p className="mt-3 font-display text-base italic text-cream/60">
            The kitchen behind the house.
          </p>
        </div>
        <form onSubmit={submit} className="mt-12 space-y-6">
          <Field label="Username">
            <input
              data-testid="login-username"
              className={inputCls}
              value={username}
              onChange={(e) => {
                setUsername(e.target.value);
                setError("");
              }}
              autoComplete="username"
            />
          </Field>
          <Field label="Password">
            <input
              data-testid="login-password"
              type="password"
              className={inputCls}
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError("");
              }}
              autoComplete="current-password"
            />
          </Field>
          {error && (
            <p data-testid="login-error" className="border-l-2 border-terra/70 pl-3 font-body text-xs font-light text-terra">
              {error}
            </p>
          )}
          <button
            data-testid="login-submit-btn"
            type="submit"
            className="w-full rounded-full border border-brass/70 py-3.5 font-body text-[11px] tracking-[0.4em] uppercase text-brass transition-all duration-300 hover:bg-brass hover:text-ink"
          >
            Enter the Veedu
          </button>
        </form>
        <a
          data-testid="login-back-link"
          href="/"
          className="mt-10 block text-center font-body text-[10px] tracking-[0.35em] uppercase text-cream/45 transition-colors hover:text-brass"
        >
          ← Back to Veedu
        </a>
      </div>
    </div>
  );
};

export default AdminLogin;
